import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';

import App from './App';
import * as serviceWorker from './serviceWorker';
import './styles/main.scss';
import {loadOneTrust} from './utils/loadOneTrust';

// Load OneTrust
loadOneTrust();

const root = createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

serviceWorker.unregister();
